import { createElement, memo, useCallback, useMemo, useState } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
import Image from '@max/leez-image';
import './index.scss';
import BottomSliderModal from './components/bottom-slider-modal';
import HotelCard from './components/hotel-card';
import InviteButton from './components/invite-button';
import { useCore } from './hooks/useCore';
import { useShare } from "./hooks/useShare/useShare.web";
import { BID_TYPE } from './const/bid';
import { NO_POI_IMG } from './const';
import { replaceWH } from './utils/image';
// 将API数据转换为组件所需的格式
const transformProductToHotelCard = (product, isCompare) => ({
    poiId: String(product.poiId || product.poiIdStr),
    poiName: product.poiName,
    frontImg: product.frontImg,
    tags: product.attributeTags?.map(tag => tag.title) || [],
    recommendReason: product.recommendReason,
    trafficInfo: product.trafficInfo,
    location: product.positionInfo?.join(' · ') || '',
    distance: product.trafficInfo?.distance || '',
    originalPrice: Number(product.originalPrice) || undefined,
    currentPrice: Number(product.price) || 0,
    priceLabel: '起',
    isRecommended: isCompare,
    isSelected: false,
    hasDiscount: Number(product.originalPrice) > Number(product.price),
    discountText: product.pushText,
    features: product.featureDesc || [],
    latitude: product.latitude,
    longitude: product.longitude
});
const MyComponent = (props) => {
    // 使用核心业务逻辑 hook
    const { visible, setVisible, ctx, isMainState, userInfo, sharePoiList, isLoading, isSuccess, isError, response, refetch, hasData, navigateToDetail, toast, changeComparePoi, productInfoList, surroundingRecSupplyList, user } = useCore(props);
    const { shareHotelLimitNum = 5 } = props;
    // 埋点上报
    function lxReport(bid, bidType, extraVal) {
        try {
            const { hotelchannel } = ctx._runtimeInfo?.queryParams || {};
            const lxCommonParams = {
                hotel_channel: hotelchannel,
                userId: userInfo?.userId
            };
            const valLab = extraVal ? {
                ...lxCommonParams,
                ...extraVal
            } : lxCommonParams;
            switch (bidType) {
                case BID_TYPE.MV:
                    ctx?._LXReport?.mvReport(bid, {
                        valLab: {
                            ...valLab,
                            custom: valLab
                        }
                    });
                    break;
                case BID_TYPE.MC:
                    ctx?._LXReport?.mcReport(bid, {
                        valLab: {
                            ...valLab,
                            custom: valLab
                        }
                    });
                    break;
                case BID_TYPE.MC_WITH_TAG:
                    ctx?._LXReport?.mcReportWithTag(bid, {
                        valLab: {
                            ...valLab,
                            custom: valLab
                        }
                    });
                    break;
            }
        }
        catch (error) {
            ctx._raptorReport.reportLog('上报埋点异常', error, {
                category: 'jsError',
                level: 'warn',
                tags: {
                    bid
                }
            });
        }
    }
    // 管理酒店选择状态
    const [selectedPoiIds, setSelectedPoiIds] = useState(() => {
        const selectedPoiIds = new Set();
        if (sharePoiList?.length) {
            sharePoiList?.forEach((item) => selectedPoiIds.add(item.poiId));
        }
        return selectedPoiIds;
    });
    // 有且只有主态情况下，返回的productInfoList才是比价酒店
    const comparePoiList = useMemo(() => {
        return productInfoList.filter(item => item.onSale).map(item => {
            const hotelData = transformProductToHotelCard(item, isMainState);
            return {
                ...hotelData,
                isSelected: selectedPoiIds.has(hotelData.poiId)
            };
        });
    }, [productInfoList, selectedPoiIds, isMainState]);
    const recommendPoiList = useMemo(() => {
        return surroundingRecSupplyList.filter(item => item.onSale).map(item => {
            const hotelData = transformProductToHotelCard(item, false);
            return {
                ...hotelData,
                isSelected: selectedPoiIds.has(hotelData.poiId)
            };
        });
    }, [surroundingRecSupplyList, selectedPoiIds]);
    const { shareWXCard } = useShare(props.shareType);
    const handleInvite = () => {
        const filterSelectedPoiList = [...(isMainState ? [] : comparePoiList), ...recommendPoiList].filter(item => item.isSelected);
        if (filterSelectedPoiList.length === 0) {
            return;
        }
        const sharePoiList = filterSelectedPoiList.map(item => {
            return {
                poiId: item.poiId,
                latitude: item.latitude,
                longitude: item.longitude
            };
        });
        shareWXCard({
            params: {
                inviteUserId: userInfo?.userId,
                sharePoiList: JSON.stringify(sharePoiList)
            },
            shareConfig: {
                ...props.shareConfig,
                shareImg: replaceWH(filterSelectedPoiList?.[0]?.frontImg || '') || props.shareConfig?.shareImg
            }
        });
    };
    const handleSelect = (poiId) => {
        setSelectedPoiIds(prev => {
            const newSet = new Set(prev);
            if (newSet.has(poiId)) {
                newSet.delete(poiId);
            }
            else {
                if (prev.size >= shareHotelLimitNum) {
                    toast(`最多分享${shareHotelLimitNum}个酒店哦～`);
                    return prev;
                }
                newSet.add(poiId);
            }
            return newSet;
        });
    };
    const handleNavigate = (poiId) => {
        navigateToDetail(poiId);
    };
    // 渲染酒店列表
    const renderHotelList = () => {
        return <View className="hotel-comparison__section">
        {/* 主推荐酒店 */}
          <>
            
            {comparePoiList.map(item => {
                return <HotelCard {...item} isRecommended={!isMainState} onSelect={handleSelect} handleNavigate={handleNavigate}/>;
            })}
            
          </>


        {/* 其他推荐酒店 */}
        {recommendPoiList.length > 0 ? <>
            <Text className="hotel-comparison__section-title">
              已帮你选择的相似酒店
            </Text>
            {recommendPoiList.map(hotel => <HotelCard {...hotel} isRecommended={true} onSelect={handleSelect} handleNavigate={handleNavigate}/>)}
          </> : <View x-if={!isLoading} className="no-recommend">
            <Image source={{
                    uri: NO_POI_IMG
                }} style={{
                    width: "200rpx",
                    height: '200rpx',
                    marginTop: '200rpx'
                }}></Image>
            <Text className="no-recommend-text">附近暂无相似的酒店推荐，可以换一换试试</Text>
          </View>}
      </View>;
    };
    // 渲染内容
    const renderContent = () => {
        return renderHotelList();
    };
    const handleClose = useCallback(() => {
        setVisible(false);
        setSelectedPoiIds(new Set());
    }, []);
    return <View>
      <BottomSliderModal visible={visible} onClose={handleClose} onModalShow={() => { }} title={isMainState ? "选择类似酒店进行比价" : "好友推荐了以下酒店给你"} isMainState={isMainState} height={1200} user={user}>
        <View className="hotel-comparison">
          <ScrollView className="hotel-comparison__scroll">
            {renderContent()}
          </ScrollView>
          <InviteButton onInvite={handleInvite} onClose={handleClose} onRefresh={() => {
            setSelectedPoiIds(new Set());
            changeComparePoi();
        }} isMainState={isMainState} user={user} lxReport={lxReport}/>
        </View>
      </BottomSliderModal>
    </View>;
};
export default memo(MyComponent);
